import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "common-rewards-popup" }
const _hoisted_2 = { class: "popup-main" }
const _hoisted_3 = { class: "popup-content" }
const _hoisted_4 = { class: "reward-title" }
const _hoisted_5 = { class: "common-rewards" }
const _hoisted_6 = { class: "reward-icon-bg" }
const _hoisted_7 = {
  key: 0,
  class: "reward-amount"
}
const _hoisted_8 = {
  key: 1,
  class: "reward-amount"
}
const _hoisted_9 = {
  key: 2,
  class: "reward-amount"
}
const _hoisted_10 = ["innerHTML"]

import { ref, onMounted } from 'vue';
import { useAudio} from '@/hooks';
import { useAccountStore, usePopupStore } from '@/store';


export default {
  __name: 'Reward',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const { playAudio } = useAudio();

const accountStore = useAccountStore();
const popupStore = usePopupStore();
const { rewards, rewardInfo } = popupStore;

onMounted(() => {
  playAudio('open');
  accountStore.fetchBalance();
})

return (_ctx, _cache) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: true,
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createVNode(_component_van_icon, {
            class: "close-icon",
            name: "close",
            onClick: _cache[0] || (_cache[0] = $event => (emit('onClose')))
          }, null, 512), [
            [_directive_audio, void 0, "close"]
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('reward.congratulation').toUpperCase()), 1),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rewards), (item) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["reward-item", { single: _unref(rewards).length === 1 }]),
                  onClick: _cache[1] || (_cache[1] = $event => (emit('onClose')))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_van_image, {
                      class: "reward-icon",
                      fit: "contain",
                      src: require(`@/assets/img/common/reward/type/${item.type}.png`)
                    }, null, 8, ["src"])
                  ]),
                  (item.type === 'cash')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.amount) + "P", 1))
                    : (item.type === 'coupon')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, "x" + _toDisplayString(item.amount), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.amount), 1))
                ], 2)), [
                  [_directive_audio, void 0, "close"]
                ])
              }), 256))
            ]),
            _createElementVNode("div", {
              class: "info-text",
              innerHTML: _unref(rewardInfo) || _ctx.$t('reward.info')
            }, null, 8, _hoisted_10)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

}